<section 
  data-component="popup-content" 
  [ngClass]="(isOpen) ? 'popup-opened' : 'popup-closed'">

  <div
    class="clickable-backdrop"
    (click)="onBackdropClick($event)">
    <div 
      class="visible-backdrop" 
      [attr.aria-hidden]="isOpen ? false : true" [ngClass]="(popupContentComponent ==='popup-site-bookmark')?'bookmarkEnabled':''">
    </div>
  </div>
  <div class="align-content" [ngClass]="(popupContentComponent ==='popup-site-bookmark')?'bookmarkForIsos':''">
    <div 
      class="content" 
      (keydown)="onKeydown($event)"
      (keyup)="onKeyup($event)">

      <!-- Registered popup content components -->
      <ng-container *ngIf="popupContentComponent==='popup-site-limited-access'">
        <popup-site-limited-access></popup-site-limited-access>
      </ng-container>
      <ng-container *ngIf="popupContentComponent==='popup-site-speedbump'">
        <popup-site-speedbump [params]="params"></popup-site-speedbump>
      </ng-container>
      <ng-container *ngIf="popupContentComponent==='popup-site-redirect'">
        <popup-site-redirect [params]="params"></popup-site-redirect>
      </ng-container>
      <ng-container *ngIf="popupContentComponent==='popup-site-bookmark'">
        <popup-site-bookmark></popup-site-bookmark>
      </ng-container>
      <ng-container *ngIf="popupContentComponent==='popup-site-info'">
        <popup-site-info></popup-site-info>
      </ng-container>
      <ng-container *ngIf="popupContentComponent==='popup-site-disclosure-tnc'">
        <popup-site-disclosure-tnc [params]="params"></popup-site-disclosure-tnc>
      </ng-container>

      

    </div>
  </div>
</section>
